import React from 'react';
import styled from 'styled-components';
import Sticky from 'react-stickynode';
//
import Arrow from 'components/svg/arrow-down';
//
export default ({ activateFilter, activeFilter, filters }) => {
  const filterArray = Object.entries(filters);
  const items = filterArray.filter((item) => item[1].total > 1);

  if (!items || items.length < 1) {
    return null;
  }

  return (
    <Sticky innerZ={100}>
      <Wrap>
        {items.map((item) => (
          <Item
            key={item[1].filter}
            active={activeFilter === item[1].filter || activeFilter === '*'}
            onClick={(e) => activateFilter(e, item[1].filter)}
          >
            {item[1].title}
            <Arrow />
          </Item>
        ))}
      </Wrap>
    </Sticky>
  );
};
//
const Wrap = styled.div`
  background-color: #fff;
  display: flex;
  justify-content: center;
  padding: 1rem 0 1rem 2rem;

  @media (min-width: 768px) {
    justify-content: flex-end;
    padding: 1vw 0 0.5vw;
  }
`;

const Item = styled.button`
  background-color: transparent;
  border: 0;
  cursor: pointer;
  font-weight: bold;
  opacity: ${({ active }) => (active ? 1 : 0.25)};
  outline: 0;
  padding: 0 1vw;

  svg {
    display: block;
    margin: 0 auto;
    opacity: ${({ active }) => (active ? 1 : 0)};
    width: 1rem;

    path {
      fill: currentColor;
      transition: fill 150ms ease-in-out;
    }
  }
`;
